import { WebhooksModule } from '@/components/modules/Webhooks/Webhooks';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { APP_ROLES, APP_USER_TYPES } from '@/config/config';
import { PageScheme } from '@/config/types';

export const PAGE_INTEGRATIONS: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.INTEGRATIONS,
  schemesByRoles: [
    {
      roles: [APP_ROLES.MERCHANT],
      titleTextId: 'INTEGRATIONS',
      widgets: [],
    },
  ],
  sections: [
    {
      textId: 'WEBHOOKS',
      module: (
        <WebhooksModule
          permissions={{
            view: [APP_USER_TYPES.MERCHANT],
            edit: [APP_ROLES.MERCHANT],
          }}
        />
      ),
    },
  ],
};
